<template>
  <div class="table-pagination">
    <div class="table-pagination__left">
      <select
        :id="selectId"
        :value="modelValue"
        class="table-pagination__select"
        aria-label="Rows per page"
        @change="onPageSizeChange"
      >
        <option v-for="option in pageSizeOptions" :key="option" :value="option">
          {{ option }}
        </option>
      </select>
      <label :for="selectId" class="table-pagination__label">per page</label>
    </div>

    <div class="table-pagination__summary">
      <span class="table-pagination__range-strong">{{ displayStart }}–{{ displayEnd }}</span>
      <span>of {{ totalCount }}</span>
    </div>

    <nav class="table-pagination__nav" aria-label="Pagination">
      <button
        type="button"
        class="table-pagination__nav-btn"
        :disabled="!hasPrevPage"
        aria-label="Previous page"
        @click="$emit('prev')"
      >
        <span class="table-pagination__nav-btn-icon" aria-hidden="true">&lt;</span>
      </button>

      <span class="table-pagination__page-indicator" aria-current="page"
        >{{ page }} / {{ totalPages }}</span
      >

      <button
        type="button"
        class="table-pagination__nav-btn"
        :disabled="!hasNextPage"
        aria-label="Next page"
        @click="$emit('next')"
      >
        <span class="table-pagination__nav-btn-icon" aria-hidden="true">&gt;</span>
      </button>
    </nav>
  </div>
</template>

<script>
let paginationSelectCounter = 0

export default {
  name: 'BasePagination',
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    displayStart: {
      type: Number,
      required: true,
    },
    displayEnd: {
      type: Number,
      required: true,
    },
    hasPrevPage: {
      type: Boolean,
      default: false,
    },
    hasNextPage: {
      type: Boolean,
      default: false,
    },
    pageSizeOptions: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
  },
  emits: ['update:modelValue', 'page-size-change', 'prev', 'next'],
  setup(props, { emit }) {
    const selectId = `pagination-page-size-${++paginationSelectCounter}`

    function onPageSizeChange(event) {
      const value = Number(event.target.value)
      emit('update:modelValue', value)
      emit('page-size-change', value)
    }

    return {
      selectId,
      onPageSizeChange,
    }
  },
}
</script>
